import React from 'react';

export default function OrderReceived({ orderId, onClose }) {
  return (
    <div 
      className="order-received-backdrop"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        animation: 'orderReceivedFadeIn 0.25s ease-out forwards',
      }}
    >
      <div 
        className="order-received-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#ffffff',
          borderRadius: '20px',
          maxWidth: '460px',
          width: '100%',
          padding: '2.5rem 2rem',
          textAlign: 'center',
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
          position: 'relative',
          animation: 'orderReceivedPopUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards',
        }}
      >
        {/* Close Button Top Right */}
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: '#F3F4F6',
            border: 'none',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.2rem',
            color: '#4B5563',
            cursor: 'pointer',
            transition: 'background 0.2s ease',
          }}
        >
          ✕
        </button>

        {/* Animated Success Badge */}
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#ECFDF5',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.25rem auto',
          border: '3px solid #10B981',
          boxShadow: '0 8px 20px rgba(16, 185, 129, 0.25)',
        }}>
          <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '0.5rem', color: '#111827' }}>
          Order Received!
        </h2>
        
        <p style={{ color: '#4B5563', fontSize: '1.05rem', lineHeight: '1.5', marginBottom: '1.5rem' }}>
          Thank you for booking with <strong>Doorstep Mobile Repair (DSMR)</strong>. Our technician will contact you shortly to confirm details.
        </p>

        {orderId && (
          <div style={{ 
            background: '#F8FAFC', 
            border: '1px solid #E2E8F0',
            padding: '0.85rem 1rem', 
            borderRadius: '12px', 
            marginBottom: '1.5rem', 
            fontWeight: 600, 
            color: '#1E293B',
            display: 'inline-block',
            fontSize: '0.95rem'
          }}>
            Order Reference ID: <span style={{ color: '#0F172A', fontWeight: 700 }}>#{orderId}</span>
          </div>
        )}

        <div>
          <button 
            onClick={onClose}
            style={{ 
              background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)', 
              color: '#ffffff', 
              padding: '0.85rem 2.25rem', 
              borderRadius: '10px', 
              border: 'none', 
              fontSize: '1rem',
              fontWeight: 700, 
              cursor: 'pointer',
              boxShadow: '0 4px 14px rgba(15, 23, 42, 0.25)',
              transition: 'transform 0.15s ease, boxShadow 0.15s ease',
              width: '100%',
            }}
          >
            Done & Continue
          </button>
        </div>

        <style>{`
          @keyframes orderReceivedFadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes orderReceivedPopUp {
            from { opacity: 0; transform: scale(0.85) translateY(10px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
          }
        `}</style>
      </div>
    </div>
  );
}
